import React, { Component } from 'react';

import './Spinner.css';

export default class Spinner extends Component {
  render() {
    return (
      <div className="loading_wrapper">
        <div className="loading_container">
          <div id="floatingCirclesG">
            <div className="f_circleG" id="frotateG_01" />
            <div className="f_circleG" id="frotateG_02" />
            <div className="f_circleG" id="frotateG_03" />
            <div className="f_circleG" id="frotateG_04" />
            <div className="f_circleG" id="frotateG_05" />
            <div className="f_circleG" id="frotateG_06" />
            <div className="f_circleG" id="frotateG_07" />
            <div className="f_circleG" id="frotateG_08" />
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./packages/smart-home-support/pages/experiences/components/common/Spinner/Spinner.js